module.exports = __webpack_public_path__ + "static/media/dewpoint.df7d48b1.svg";